export default {
  renderOption(data) {
    const value = data[this.valueField] || data.toString();
    const text = data[this.textField] || data.toString();
    const isChecked = this.selectedValues.indexOf(value.toString()) > -1;

    const html = `<li tabindex="0">
              <label class="${ this.multiple ? 'checkbox' : 'radio' }">
                <input type="${ this.multiple ? 'checkbox' : 'radio' }"
                       name="${ this.name }${ this.multiple ? '[]' : '' }"
                       value="${ value }"
                       data-summary-label="${ this.placeholder }"
                       data-summary-display="${ text }"
                       ${isChecked ? 'checked' : '' }>
                <span>${ text }</span>
              </label>
            </li>`;

    if (this.optionRenderingFunction) {
      return this.optionRenderingFunction({
        value,
        text,
        isChecked,
        option: data,
        name: this.name,
        placeholder: this.placeholder,
        multiple: this.multiple,
        defaultHtml: html
      });
    }

    return html;
  },

  renderOptions(data, replace = false, trigger = true) {
    if (!this.ajax) return;

    const $list = $('.q-options', this.$component);

    if (this.isDataFetched && !data.length) {
      $list.html(`<div class="q-empty">${this.blankMessage || "Nenhum resultado"}</div>`);

      if (this.multiple)
        this.updateCounter();
      else
        this.updateSelected();

      return;
    } else if (!this.isDataFetched && !data.length) {
      return;
    }

    const options = data.map(option => this.renderOption(option));

    if (replace)
      $list.html(options);
    else
      $list.append(options);

    this.renderedValues = this.renderedValues.concat(data);
    this._ensureHiddenOptions(data);

    const $inputs = $('input[checked]', this.$component);
    $inputs.prop('checked', true);

    if (trigger) $inputs.trigger('change');

    if (this.multiple)
      this.updateCounter();
    else
      this.updateSelected();

    this._execCallbacks('render', this.$component.get(0));
  },

  renderError(errorMessage) {
    const $list = $('.q-options', this.$component);
    $list.html(`<div class="q-empty q-error">${errorMessage}</div>`);
  },

  updateCounter(count) {
    const $count = this.$component.find('.dropdown-toggle .q-count');
    count = count || this.selectedValues.length;

    if (count > 0)
      $count.html(`${count} selecionado${count > 1 ? 's' : ''}`);
    else if (count === 0)
      $count.html('');
  },

  getSelectedCount() {
    let count = this.selectedValues.length;

    if (!this.ajax)
      count = $('input:checked', this.$component).length;

    return count;
  },

  unselectAll() {
    $('.selected', this.$component).removeClass('selected');
  },

  select($option) {

    if (this.getSelectedCount > this.options.limit) return;

    const $input = $option.find('input');
    const $placeholder = $('.dropdown-toggle .q-placeholder', this.$component);
    const isChecked = $input.is(':checked');
    const selectedText = $input.data('summary-display') || $input.next('span').html() || $input.val();
    const hasPlaceholder = !this.hidePlaceholderWhenSelect && !!this.placeholder && this.placeholder.length;
    const hasSelectedText = !!selectedText && selectedText.length;
    let display = '';

    if (hasPlaceholder) display += this.placeholder.trim();
    if (hasPlaceholder && hasSelectedText) display += ': ';
    if (hasSelectedText) display += selectedText.trim();

    this.unselectAll();

    if (isChecked) {
      $option.addClass('selected');
      $placeholder.html(display);
      this.$component.attr('title', display);
    } else {
      $placeholder.html(this.placeholder);
      this.$component.attr('title', '');
    }

    this.close();
  },

  updateSelected() {
    const $placeholder = $('.dropdown-toggle .q-placeholder', this.$component);
    const $input = $('input:checked', this.$component);

    const value = $input.val();
    const option = this.options.find(o => o[this.config.valueField] === value);
    const optionDisplay = option ? option[this.config.textField] : null;

    if ($input.length) {
      const display = `${this.placeholder ? this.placeholder + ': ' : ''}
      ${$input.data('summary-display') || optionDisplay || value}`;

      $input.parents('li').addClass('selected');
      $placeholder.html(display);
      this.$component.attr('title', display);
    } else
      this.unselectAll();
  }
};
